/**
 * Remembers the market a trader was last viewing so the "Markets" nav returns them
 * to that exact market (e.g. BTC) instead of always resetting to the default.
 *
 * Default (first visit / nothing saved) is Los Angeles, matching the app's landing route.
 */
const KEY = "lastMarketPath";
const DEFAULT_MARKET_PATH = "/perps/markets/realestate/losangeles";

// Only treat actual market-detail pages as "markets" (type + id), e.g.
// /perps/markets/crypto/btc, /perps/markets/realestate/losangeles.
const MARKET_DETAIL_RE = /^\/perps\/markets\/(crypto|realestate|rwa|watch|stocks|commodities|poc)\/[^/]+$/;

export const isMarketDetailPath = (path) => MARKET_DETAIL_RE.test(path || "");

/** Persist the current market-detail path (no-op for any other path). */
export const setLastMarketPath = (path) => {
  try {
    if (isMarketDetailPath(path)) localStorage.setItem(KEY, path);
  } catch (_) {
    // localStorage unavailable (private mode etc.) — silently ignore.
  }
};

/** The market the user was last on, or the Los Angeles default. */
export const getLastMarketPath = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved && isMarketDetailPath(saved)) return saved;
  } catch (_) {
    // ignore
  }
  return DEFAULT_MARKET_PATH;
};
